import { render, staticRenderFns } from "./activityManage.vue?vue&type=template&id=74578408&scoped=true"
import script from "./activityManage.vue?vue&type=script&lang=js"
export * from "./activityManage.vue?vue&type=script&lang=js"
import style0 from "./activityManage.vue?vue&type=style&index=0&id=74578408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74578408",
  null
  
)

export default component.exports